// extracted by mini-css-extract-plugin
export default {"confirmationAction":"ConfirmationAction_confirmationAction__UzaWk"};